var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35318 7.85367C6.25942 7.94741 6.13227 8.00006 5.99968 8.00006C5.8671 8.00006 5.73995 7.94741 5.64618 7.85367L2.81768 5.02517C2.76993 4.97905 2.73184 4.92388 2.70563 4.86287C2.67943 4.80187 2.66563 4.73626 2.66506 4.66987C2.66448 4.60348 2.67713 4.53764 2.70227 4.47619C2.72741 4.41475 2.76454 4.35892 2.81149 4.31197C2.85843 4.26503 2.91426 4.2279 2.97571 4.20276C3.03715 4.17762 3.10299 4.16497 3.16938 4.16555C3.23577 4.16612 3.30138 4.17992 3.36239 4.20612C3.42339 4.23233 3.47856 4.27042 3.52468 4.31817L5.99968 6.79317L8.47468 4.31817C8.56899 4.22709 8.69529 4.1767 8.82638 4.17783C8.95748 4.17897 9.08289 4.23156 9.17559 4.32426C9.2683 4.41697 9.32088 4.54237 9.32202 4.67347C9.32316 4.80457 9.27276 4.93087 9.18168 5.02517L6.35318 7.85367Z",
    fill: "#1D1B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.bc3c8a0bf50ed2aae655d5f2b9ab82b1.svg";
export { ForwardRef as ReactComponent };